import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { RawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import history from "web/script/utils/history";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import globals from "web/script/modules/globals";
import classnames from "classnames";
var SOFT_BLOCK = "soft_block";
var HARD_BLOCK = "hard_block";
var NO_BLOCK = "no_block";
var TITLE_1 = "title_1";
var TITLE_2 = "title_2";
var TITLE_3 = "title_3";
var TITLE_4 = "title_4";
var APP_MODAL_NAME = "send-to-app-on-oos-related-show-more-modal";
export function RelatedProductsShowMore(section) {
  var isIos = browser.ios;
  var productIsInstock = section.product_is_instock != null && section.product_is_instock;
  var blockVariant;

  if (isIos) {
    blockVariant = productIsInstock ? environment.getFeature("mg_block_is_related_show_more") : environment.getFeature("mg_block_oos_related_show_more");
  } else {
    blockVariant = NO_BLOCK;
  }

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      blocked = _useState2[0],
      setBlocked = _useState2[1];

  var blockModalIsOpen = !!useOverlayWatcher(APP_MODAL_NAME);
  var branchLink = productIsInstock ? RawBranchLink.InStockShowMore : RawBranchLink.OutOfStockShowMore;
  var titleVariant = productIsInstock ? environment.getFeature("mg_block_is_related_show_more_title") : environment.getFeature("mg_block_oos_related_show_more_title");
  var blockingTitle = "";

  if (titleVariant == TITLE_1) {
    blockingTitle = productIsInstock ? // "Shop the world’s biggest and best selection of fashion"
    gettext("in_stock_product.related_show_more.app_overlay_block.title_1") : // "Shop the world’s biggest and best selection of fashion"
    gettext("oos_product.related_show_more.app_overlay_block.title_1");
  } else if (titleVariant == TITLE_2) {
    blockingTitle = productIsInstock ? // "The hottest and newest products from over 12,000 brands"
    gettext("in_stock_product.related_show_more.app_overlay_block.title_2") : // "The hottest and newest products from over 12,000 brands"
    gettext("oos_product.related_show_more.app_overlay_block.title_2");
  } else if (titleVariant == TITLE_3) {
    blockingTitle = productIsInstock ? // "Can’t find what you’re looking for? The Lyst App is personalised to you"
    gettext("in_stock_product.related_show_more.app_overlay_block.title_3") : // "Can’t find what you’re looking for? The Lyst App is personalised to you"
    gettext("oos_product.related_show_more.app_overlay_block.title_3");
  } else if (titleVariant == TITLE_4) {
    blockingTitle = productIsInstock ? // "Still not sure what you want? Keep track of your favourite items in the app"
    gettext("in_stock_product.related_show_more.app_overlay_block.title_4") : // "Still not sure what you want? Keep track of your favourite items in the app"
    gettext("oos_product.related_show_more.app_overlay_block.title_4");
  }

  function onBlockModalOpen() {
    // I check the current overlay state instead of modalIsOpen
    // to get around the delay introduced by hooks
    if (history.getCurrentState().overlay !== APP_MODAL_NAME) {
      history.pushOverlay(APP_MODAL_NAME);
    }
  }

  function onButtonClick() {
    analytics.event("navigation", "show_more_related", "show_feed");

    if (isIos && !userProfiler.isLoggedIn()) {
      if (blockVariant == HARD_BLOCK) {
        onBlockModalOpen();
        return;
      } else if (blockVariant == SOFT_BLOCK && blocked) {
        setBlocked(false);
        onBlockModalOpen();
        return;
      }
    } // If we don't meet the requirements to open the modal, we use default behaviour


    globals.window.location.href = section.view_more_url;
  }

  function onBlockModalClose() {
    history.popOverlay(APP_MODAL_NAME); // when dismissing a soft block we will open the feature

    if (blockVariant === SOFT_BLOCK) {
      globals.window.location.href = section.view_more_url;
    }
  }

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPaywalled = _useState4[0],
      setIsPaywalled = _useState4[1];

  var paywalledClassName = "paywalled-content";
  useEffect(function () {
    setIsPaywalled(blockVariant === HARD_BLOCK);
  }, [blockVariant]);
  return React.createElement("div", {
    className: classnames(_defineProperty({}, paywalledClassName, isPaywalled))
  }, React.createElement("button", {
    className: "btn btn-primary related-show-more",
    onClick: onButtonClick
  }, gettext("product.related_products.show_me_more")), React.createElement(SendToAppModal, {
    title: blockingTitle,
    url: branchLink,
    isOpen: blockModalIsOpen,
    onClose: onBlockModalClose,
    analyticsEventLabel: "oos_related_show_more",
    paywalledClassName: isPaywalled ? paywalledClassName : null
  }));
}
export default RelatedProductsShowMore;